/** @jsx jsx */
import * as React from "react"
import { connect } from "react-redux";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap"
import { IAppointmentScheduleResponse, IPatientDetail } from "@curefit/care-common";
import { AppointmentsActions } from "../../actions/AppointmentsActions";
import * as _ from "lodash";
import * as RoutesConfig from "../../routes"
import PatientConsultationCard from "../../components/patient/PatientConsultationCard";
import AppUtils, { LOADING_STATE } from "../../utils/AppUtils"
import AppLoader from "../../components/utils/AppLoader";
import { APP_TENANTS, ConsultationStatusConstant, SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS } from "../../utils/AppConstants";
import { IAppState } from "../../models/IAppState";
import { ConsultationStatusConstant } from "../../utils/AppConstants";
import { IAppState } from "../../models/IAppState";
import { EventNames } from "../../utils/EventTrackerConstants";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import { TwilioActions } from "../../actions/TwilioActions";
import { css, jsx } from "@emotion/core";
import { patientAllCons } from "../../styles/patientAllCons/mobile/patientAllCons";
import { WhatsAppChatActions } from "../../actions/WhatsAppChatActions";
import { WhatsAppPatientInfo } from "../../components/WhatsAppChatComponent";

export interface PatientConsultationsContainerProps {
    params: any,
    consultations: IAppointmentScheduleResponse[],
    doctorId: number,
    getConsultationsForPatient: (patientId: number) => Promise<any>,
    updateCurrentChannelWithPatient(channelSid: string, patient: IPatientDetail, memberIdentity: string): any,
    chatClients: { [key: string]: any },
    updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => void,
    closeWhatsAppChatContext: () => void,
    appTenant?:string,
    doctorType?:string,
}

export interface PatientConsultationsContainerState {
    isConsultationsLoaded: LOADING_STATE
}

class PatientConsultationsContainer extends React.Component<PatientConsultationsContainerProps, PatientConsultationsContainerState> {
    private loadStartTime: number = AppUtils.getCurrentTime()
    constructor(props: PatientConsultationsContainerProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    };

    getPatientId = (newProps: PatientConsultationsContainerProps): number => {
        if (newProps.params[RoutesConfig.PATIENT_ID_PARAM]) {
            return parseInt(newProps.params[RoutesConfig.PATIENT_ID_PARAM]);
        }
        return parseInt(this.props.params[RoutesConfig.PATIENT_ID_PARAM]);
    }

    getStateFromProps(props: PatientConsultationsContainerProps) {
        let isConsultationsLoaded = LOADING_STATE.NOT_INITIALIZED;
        if (_.isNull(props.consultations)) {
            isConsultationsLoaded = LOADING_STATE.LOADING;
            this.props.getConsultationsForPatient(this.getPatientId(props))
                .then(() => {
                    AppUtils.updatePageLoadEvent(EventNames.All_Consultations, "", this.loadStartTime);
                    this.openChat();
                });
        } else {
            isConsultationsLoaded = LOADING_STATE.LOADED;
        }
        return {
            isConsultationsLoaded: isConsultationsLoaded
        }
    }

    componentWillReceiveProps(newProps: PatientConsultationsContainerProps) {
        this.setState(this.getStateFromProps(newProps));
    }

    getFilteredConsultaions = () => {
        let isAllDataLoaded = this.state.isConsultationsLoaded === LOADING_STATE.LOADED
        let consultations: IAppointmentScheduleResponse[] = [];
        if (isAllDataLoaded) {
            consultations = (_.map(this.props.consultations) || []).sort(function (appt1, appt2) {
                return appt1.startTime > appt2.startTime ? -1 : 1;
            });
            consultations = consultations.filter(consultation => consultation.status !== ConsultationStatusConstant.WAITING_FOR_CONFIRMATION && consultation.status !== ConsultationStatusConstant.BOOKED && consultation.status !== ConsultationStatusConstant.CANCELLED);
        }
        return consultations;
    }

    openChat = () => {
        let consultations = this.getFilteredConsultaions();
        if (consultations && consultations[0] && consultations[0].appointmentActionsWithContext
            && consultations[0].appointmentActionsWithContext.chatActionWithContext) {
            const chatContext = consultations[0].appointmentActionsWithContext.chatActionWithContext;
            const patient = consultations[0].patient;
            const memberIdentity: string = _.get(chatContext, "context.twilioCommunicationMode.doctorTwilioUser.identity", "")
            const chatClientsArr = Object.keys(this.props.chatClients || {})
            const actionPermitted = _.get(chatContext, "action.actionPermitted", false)

            if(this.props.appTenant === APP_TENANTS.SUGARFIT && this.props.doctorType === SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS.LIFESTYLE_COACH){
                const whatsAppPatientInfo: WhatsAppPatientInfo = {
                    doctorId: this.props.doctorId,
                    name: patient.name,
                    mobileNo: patient.userPhoneNumber || patient.phoneNumber
                }
                this.setWhatsAppContext(whatsAppPatientInfo);
            }
            else if (!_.isEmpty(chatClientsArr) && chatClientsArr.includes(memberIdentity) && actionPermitted) {
                this.props.updateCurrentChannelWithPatient(chatContext.context.twilioCommunicationMode.modeSid, patient, memberIdentity);
            }
        }
    }

    setWhatsAppContext = (patientInfo: WhatsAppPatientInfo) => {
        this.props.closeWhatsAppChatContext();
        setTimeout(() => this.props.updateWhatsAppChatContext(patientInfo), 300);
    }

    render() {
        let isAllDataLoaded = this.state.isConsultationsLoaded === LOADING_STATE.LOADED
        let consultations: IAppointmentScheduleResponse[] = this.getFilteredConsultaions();

        let currTime = new Date().getTime();
        let doctorId = this.props.doctorId;
        const isMobile: boolean = AppUtils.getIsMobile();
        return (
            <div>
                {
                    isAllDataLoaded &&
                    <div className="patient-consultation-cont">
                        {isMobile &&
                            <button onClick={this.openChat} css={patientAllCons.chatHead}>
                                <img src="/images/chat-icon.svg" alt="chat-head" />
                            </button>
                        }
                        {
                            consultations.length ?
                                (
                                    <div>
                                        {!isMobile &&
                                            <div className="dummy-border-div"></div>
                                        }
                                        {
                                            _.map(consultations, (consultation: IAppointmentScheduleResponse, index) => {
                                                let dateText = AppUtils.getRelativeDay(consultation.startTime, "D MMM, Y", true);
                                                if (currTime < consultation.startTime) {
                                                    dateText = "UPCOMING, " + dateText;
                                                }
                                                return (
                                                    <div key={consultation.id} className="patient-consultation-container">
                                                        <div className="date-div brandon-bold">{dateText}</div>
                                                        <PatientConsultationCard consultation={consultation} doctorId={doctorId} />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : <div>No consultations found!</div>
                        }
                    </div>
                }
                {
                    !isAllDataLoaded && <AppLoader />
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return Object.assign({}, {
        consultations: state.patientCompleteInfo.consultations,
        doctorId: state.doctorProfile.id,
        chatClients: state.twilioContext.clients,
        appTenant: state.accountData.appTenant,
        doctorType: state.doctorProfile.type,
    });
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getConsultationsForPatient: (patientId: number) => {
            return AppointmentsActions.fetchAppointmentsForPatient(dispatch, patientId);
        },
        updateCurrentChannelWithPatient: (channelSid: string, patient: IPatientDetail, memberIdentity: string) => {
            return dispatch(TwilioActions.updateCurrentChannelWithPatient(channelSid, patient, memberIdentity));
        },
        closeWhatsAppChatContext: () => {
            return dispatch(WhatsAppChatActions.closeWhatsAppChat());
        },
        updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => {
            return dispatch(WhatsAppChatActions.updateWhatsAppPatientInfo(patientInfo));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientConsultationsContainer);
